import React, { useState, useEffect, useRef } from 'react';
import TopBar from '../Tools/Topbar';
import LeftSide from '../Tools/LeftSidebar';
import EmployeeTab from '../tabs/EmployeeTab';
import AttendanceTab from '../tabs/AttendanceTab';
import SpecialitiesTab from '../tabs/SpecialitiesTab';
import AssetsTab from '../tabs/AssetsTab';
import CasesTab from '../tabs/CasesTab';
import CaseReferenceTab from '../tabs/CaseReferenceTab';
import LocationTab from '../tabs/Locations';
import AreaTab from '../tabs/Area';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';

const ResourceManagement = () => {
  const [activeTab, setActiveTab] = useState('employee');
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    // Hooks and refs
  const { updateSetting, handleColorTheme, settings } = useSettings();
  const settingsRef = useRef();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const getTabLabel = (tab) => ({
    'employee': 'Employee',
    'attendance': 'Attendance',
    'specialities': 'Specialities',
    'assets': 'Assets',
    'cases': 'Cases',
    'case-reference': 'Case Reference',
    'locations': 'Locations',
    'area': 'Area',
  }[tab] || tab);

  const getTabIcon = (tab) => ({
    'employee': 'users',
    'attendance': 'list',
    'specialities': 'folder',
    'assets': 'asset',
    'cases': 'file-check',
    'case-reference': 'a-b-2',
    'locations': 'map-pin',
    'area': 'layout',
  }[tab] || 'circle');

  return (
    <div id="main-wrapper">
      <LeftSide isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <TopBar toggleSidebar={toggleSidebar} />

        <div className="body-wrapper">
          <div className="container-fluid">
             <Settings 
              ref={settingsRef}
              updateSetting={updateSetting}
              handleColorTheme={handleColorTheme}
              settings={settings}  // Add this line
            />

            <div className="card w-100 position-relative overflow-hidden">
              <div className="px-4 py-3 border-bottom">
                <h5 className="card-title fw-semibold mb-0 lh-sm">Resource Management</h5>
                <p className="card-subtitle mb-0 mt-1">Track, update, and organize resources</p>
              </div>

              <div className="card-body p-4">
                <ul className="nav nav-tabs border-bottom border-primary" role="tablist">
                  {['employee', 'attendance', 'specialities', 'assets', 'cases', 'case-reference', 'locations', 'area'].map((tab) => (
                    <li key={tab} className="nav-item" role="presentation">
                      <button
                        className={`nav-link d-flex ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab)}
                        aria-selected={activeTab === tab}
                        aria-controls={tab}
                      >
                        <span>
                          <i className={`ti ti-${getTabIcon(tab)} fs-5`}></i>
                        </span>
                        <span className="d-none d-md-block ms-2">{getTabLabel(tab)}</span>
                      </button>
                    </li>
                  ))}
                </ul>

                <div className="tab-content pt-3">
                  {activeTab === 'employee' && <EmployeeTab />}
                  {activeTab === 'attendance' && <AttendanceTab />}
                  {activeTab === 'specialities' && <SpecialitiesTab />}
                  {activeTab === 'assets' && <AssetsTab />}
                  {activeTab === 'cases' && <CasesTab />}
                  {activeTab === 'case-reference' && <CaseReferenceTab />}
                  {activeTab === 'locations' && <LocationTab />}
                  {activeTab === 'area' && <AreaTab />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dark-transparent sidebartoggler" onClick={toggleSidebar}></div>
    </div>
  );
};

export default ResourceManagement;